export default __webpack_public_path__ + "static/media/resourcesIcon.13f6391b.svg";